import { hasPermission } from "../../utils/permissions";

export default function Can({ moduleKey, action = "read", children, fallback = null }) {
  return hasPermission(moduleKey, action) ? children : fallback;
}
